@if(isLoading) {
    <app-loading-page [message]="loadingMessage"></app-loading-page>
  }
@else {
    <div class="subscription-detail-page">
  
      <!-- Top Bar -->
      <div class="header-button-combo no-stack">
        <div>
          <button kendoButton class="btn-back" (click)="onBack()">
            Subscriptions
          </button>
        </div>
        <div>
          <kendo-dropdownbutton
            [data]="actions"
            (itemClick)="onActionSelect($event)"
            class="btn--outline actions-dropdown"
            [svgIcon]="moreVerticalIcon">
            Actions
          </kendo-dropdownbutton>
        </div>       
        <!-- Actions Dropdown (top-right) with more-vertical icon -->
        <!-- <button kendoButton 
                class="update-subscription-button"
                (click)="goToBilling()">
          Go to Billing
        </button> -->
      </div>
      
      <!-- Subscription Details Section -->
      <section class="section-block">
        <h3>Subscription details</h3>
        <div class="details-row">
            <label>Label:</label>
            <ng-container *ngIf="!isEditingLabel">
              <span class="edit-label">{{ subscription?.Label || 'No Label' }}</span>
              <button kendoButton
                class="btn-edit"
                look="outline" 
                (click)="onEditLabel()"
              >
                Edit
              </button>
            </ng-container>
            <ng-container *ngIf="isEditingLabel">
              <div class="form-group-edit">
                <input kendoTextBox 
                [(ngModel)]="editedLabel" 
                autoFocus 
                [ngClass]="{'edit-mode': isEditingLabel}" />
                <button kendoButton (click)="onSaveLabel()">Save</button>
                <button kendoButton look="outline" (click)="onCancelLabelEdit()">Cancel</button>
              </div>
            </ng-container>
        </div>
        
        <div class="details-row">
          <label>Organization:</label>
          <span>{{ subscription?.Organization || 'N/A' }}</span>
        </div>
        
        <div class="details-row">
          <label>Started By:</label>
          <span>{{ customerName || 'N/A' }}</span>
        </div>
        
        <div class="details-row">
          <label>Created:</label>
          <span>{{ subscription?.StartDate | date:'mediumDate' }}</span>
        </div>
        
        <div class="details-row">
          <label>Current period:</label>
          <span>{{ currentPeriod || 'N/A' }}</span>
        </div>
        
        <div class="details-row">
          <label>Payment method:</label>
          <span>
            @if (paymentMethod?.card) {
              <img [src]="paymentMethod.cardIconUrl" [alt]="paymentMethod.card.brand" class="card-brand-icon" />
              {{ paymentMethod.card.brand }} •••• {{ paymentMethod.card.last4 }}
            }
            @else {
              N/A
            }
          </span>
        </div>
      </section>
      
      <!-- Pricing Section -->
      <section class="section-block">
        <h3>Pricing</h3>
        <div class="pricing-info">
          <div>Plan: {{ subscriptionDetails.PlanName }}</div>
          <div>Price: ${{ subscriptionDetails.Price }}/{{ subscriptionDetails.BillingPeriod }} per user</div>
          <div>Quantity: {{ subscription?.CurrentUserCount }}</div>
          <div>Total: ${{ subscriptionDetails.TotalAmount }}/{{ subscriptionDetails?.BillingPeriod?.toLowerCase() }}</div>
        </div>
      </section>
      
      <!-- Instances Section -->
      <section class="section-block">
        <div class="header-button-combo">
          <div>
            <h3>Instances</h3>
          </div>
          <div>
            <button kendoButton 
              (click)="onCreateInstance()"
              class="btn-add"
            >
              Create New Instance
            </button>
          </div>
        </div>
        <div class="grid-wrapper grid-sm">
          <kendo-grid 
            [data]="instances" 
          >
            <kendo-grid-column field="Name" title="Name">
              <ng-template kendoGridCellTemplate let-dataItem>
                  <a class="instance-link" (click)="onClickInstanceName(dataItem.ID)">{{ dataItem.Name }}</a>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Status" title="Status">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ dataItem.Status }}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Action" [width]="150">
              <ng-template kendoGridCellTemplate let-dataItem>
                <kendo-dropdownbutton
                    [data]="getInstanceActions(dataItem)"
                    [svgIcon]="moreVerticalIcon"
                    (itemClick)="onInstanceActionSelect($event, dataItem)">
                  Actions
                </kendo-dropdownbutton>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>  
        </div>
      </section>
      
      <!-- Users Section -->
      <section class="section-block">
        <h3>Users</h3>
        <div class="grid-wrapper grid-sm">
          <kendo-grid 
            [data]="users" 
          >
            <kendo-grid-column field="Contact" title="Contact"></kendo-grid-column>
            <kendo-grid-column field="Instance" title="Instance">
              <ng-template kendoGridCellTemplate let-dataItem>
                <a class="instance-link" (click)="onClickInstanceName(dataItem.InstanceID)">{{ dataItem.Instance }}</a>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Remove" [width]="150">
              <ng-template kendoGridCellTemplate let-dataItem>
                <button kendoButton 
                        look="outline" 
                        (click)="onRemoveUser(dataItem)">
                  Remove
                </button>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </section>

      <!-- Subscription History Section -->
      <section class="section-block">
        <h3>Subscription History</h3>
        <div class="grid-wrapper grid-lg">
          @if (subscriptionHistory?.length > 0) {
            <kendo-grid [data]="subscriptionHistory">
              <kendo-grid-column field="ChangeDate" title="Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.ChangeDate | date:'mediumDate' }}
                </ng-template>
              </kendo-grid-column>
              
              <kendo-grid-column field="ChangeType" title="Change Type">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.ChangeType }}
                </ng-template>
              </kendo-grid-column>
              
              <!-- Old Value Column -->
              <kendo-grid-column title="Old Value">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ getHistoryValues(dataItem)?.oldValue }}
                </ng-template>
              </kendo-grid-column>
              
              <!-- New Value Column -->
              <kendo-grid-column title="New Value">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ getHistoryValues(dataItem)?.newValue }}
                </ng-template>
              </kendo-grid-column>
              
              <kendo-grid-column field="ChangeStatus" title="Status">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="status-pill">{{ dataItem.ChangeStatus }}</span>
                </ng-template>
              </kendo-grid-column>
              
              <kendo-grid-column field="UpdatedByContact" title="Updated By">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.UpdatedByContact || 'Unknown' }}
                </ng-template>
              </kendo-grid-column>
              
              <!-- <kendo-grid-column field="Comments" title="Comments">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="text-ellipsis">{{ dataItem.Comments || '—' }}</span>
                </ng-template>
              </kendo-grid-column> -->
              
            </kendo-grid>
          } @else {
            <p>No subscription history found.</p>
          }  
        </div>
      </section>


      <!-- Upcoming Invoice Section -->
      <section class="section-block upcoming-invoice-section">
        <h3>Upcoming Invoice</h3>
        @if (upcomingInvoice) {
          <p class="upcoming-invoice-subheader">
            This is a preview of the invoice that will be billed on
            <strong>{{ upcomingInvoice.billingDate | date:'mediumDate' }}</strong>.
            It may change if the subscription is updated.
          </p>
          <div class="table-wrapper">
            <table class="invoice-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Qty</th>
                  <th>Unit price</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                @if (upcomingInvoice.lines && upcomingInvoice.lines.length > 0) {
                  @for (line of upcomingInvoice.lines; track line) {
                    <tr>
                      <td>{{ line.description }}</td>
                      <td>{{ line.quantity }}</td>
                      <td>{{ line.unitPrice | currency }}</td>
                      <td>{{ line.amount | currency }}</td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td colspan="4">No line items found.</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
      
          @if (upcomingInvoice.periodStart && upcomingInvoice.periodEnd) {
            <div class="invoice-period">
              ({{ upcomingInvoice.periodStart | date:'mediumDate' }}
               - {{ upcomingInvoice.periodEnd | date:'mediumDate' }})
            </div>
          }
      
          <div class="invoice-summary">
            <div class="invoice-summary-item">
              <span>Subtotal:</span>
              <span>{{ upcomingInvoice.subtotal | currency }}</span>
            </div>
            <div class="invoice-summary-item">
              <span>Total excluding tax:</span>
              <span>{{ upcomingInvoice.totalExcludingTax | currency }}</span>
            </div>
            <div class="invoice-summary-item">
              <span>Tax:</span>
              <span>{{ upcomingInvoice.tax | currency }}</span>
            </div>
            @if (upcomingInvoice.appliedBalance) {
              <div class="invoice-summary-item">
                <span>Applied account balance:</span>
                <span>-{{ upcomingInvoice.appliedBalance | currency }}</span>
              </div>
            }
            <div class="invoice-summary-item total-due">
              <span>Amount due:</span>
              <span>{{ upcomingInvoice.amountDue | currency }}</span>
            </div>
          </div>
        } @else {
          <p>No upcoming invoice available.</p>
        }
      </section>
      

      <section class="section-block invoice-history-section">
        <h3>Invoice History</h3>
        @if (paidInvoices?.length > 0) {
          <div class="table-wrapper">
            <table class="invoice-history-table">
              <thead>
                <tr>
                  <th>Created</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Customer email</th>
                </tr>
              </thead>
              <tbody>
                @for (inv of paidInvoices; track inv) {
                  <tr>
                    <!-- Created date/time -->
                    <td>
                      @if (inv.created) {
                        {{ inv.created | date:'mediumDate' }}<br/>
                        <span class="created-time">{{ inv.created | date:'shortTime' }}</span>
                      } @else {
                        N/A
                      }
                    </td>
  
                    <!-- Amount Column -->
                    <td>
                      @if (inv.total != null) {
                        @if (inv.total < 0) {
                          <!-- Negative amount: show as ( $49.99 ) -->
                          (${{ (-inv.total) | number:'1.2-2' }})
                        } @else {
                          <!-- Positive amount: show as $49.99 -->
                          ${{ inv.total | number:'1.2-2' }}
                        }
                      } @else {
                        N/A
                      }
                    </td>
        
                    <!-- Status (Paid, etc.) -->
                    <td>
                      @if (inv.status?.toLowerCase() === 'paid') {
                        <span class="status-pill status-paid">Paid</span>
                      } @else {
                        <span class="status-pill">{{ inv.status }}</span>
                      }
                    </td>
  
                    <!-- Customer email -->
                    <td>{{ inv.customerEmail || 'N/A' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          
        } @else {
          <p>No past invoices found.</p>
        }
      </section>
     
      
      <!-- Cancel Subscription Dialog -->
      @if (showCancelDialog) {
        <kendo-dialog (close)="showCancelDialog = false" title="Cancel Subscription">
          <p>Are you sure you want to cancel this subscription? This action cannot be undone.</p>
          <kendo-dialog-actions>
            <button kendoButton (click)="showCancelDialog = false">No</button>
            <button kendoButton themeColor="error" (click)="confirmCancelSubscription()">Yes, Cancel</button>
          </kendo-dialog-actions>
        </kendo-dialog>    
      }
      <!-- Remove User Dialog -->
      @if (showRemoveUserDialog) {
        <kendo-dialog (close)="showRemoveUserDialog = false" title="Remove User">
          <p>Are you sure you want to remove {{ userToRemove?.Contact }} from this subscription?</p>
          <!-- Subscription Update Preview -->
          <app-subscription-update-preview
            [subscription]="subscription"
            [options]="previewOptions"
            (previewLoaded)="onPreviewLoaded($event)"
          >
          </app-subscription-update-preview>
          <kendo-dialog-actions>
            <button kendoButton (click)="showRemoveUserDialog = false">Cancel</button>
            <button kendoButton [disabled]="!isPreviewLoaded" themeColor="error" (click)="confirmRemoveUser()">Confirm</button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
    </div>
}
  